var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink2 = function SvgLink2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.176 6.694a.6.6 0 0 1 0 1.2H7.294a4.107 4.107 0 0 0-2.903 7.01 4.1 4.1 0 0 0 2.903 1.201h1.882a.6.6 0 0 1 0 1.2H7.294a5.306 5.306 0 1 1 0-10.61zm7.53 0a5.306 5.306 0 0 1 0 10.612h-1.883a.6.6 0 1 1 0-1.2h1.883A4.107 4.107 0 0 0 20.811 12a4.107 4.107 0 0 0-4.105-4.107h-1.883a.6.6 0 1 1 0-1.199zm-.942 4.706a.6.6 0 1 1 0 1.2h-7.53a.6.6 0 0 1 0-1.2z"
  })));
};
export default SvgLink2;